import useSWRMutation from "swr/mutation";
import { http } from "~/services/http";

export const useCompleteInitiation = () => {
  const { trigger: completeInitiation } = useSWRMutation(
    "/api/account/complete-initiation",
    http.post
  );

  return { completeInitiation };
};
